import { type AbstractControl, type ValidatorFn } from '@angular/forms';
import { extractTextFromHtml } from '../functions/extract-text-from-html';

export const requiredIgnoreHtmlValidator: ValidatorFn = (control: AbstractControl) => {
  if (extractTextFromHtml(control.value) === '') {
    return { required: true };
  }
  return null;
};
